import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class LanguageService {
    constructor(private translate: TranslateService) { }

    initLanguage(): void {
        const browserLang = navigator.language || navigator.languages[0];

        fetch('https://ipapi.co/json/')
            .then(res => res.json())
            .then(location => {
                const countryCode = location.country;
                const spanishCountries = [
                    'MX', // Mexico
                    'ES', // Spain
                    'AR', // Argentina
                    'CO', // Colombia
                    'PE', // Peru
                    'CL', // Chile
                    'VE', // Venezuela
                    'EC', // Ecuador
                    'GT', // Guatemala
                    'CU', // Cuba
                    'BO', // Bolivia
                    'DO', // Dominican Republic
                    'HN', // Honduras
                    'PY', // Paraguay
                    'SV', // El Salvador
                    'NI', // Nicaragua
                    'CR', // Costa Rica
                    'PA', // Panama
                    'UY', // Uruguay
                    'GQ'  // Equatorial Guinea
                ];
                const isSpanish = spanishCountries.includes(countryCode) || browserLang.startsWith('es');
                const selectedLang = isSpanish ? 'es' : 'en';
                this.translate.use(selectedLang);
            })
            .catch(() => {
                this.translate.use(browserLang.startsWith('es') ? 'es' : 'en');
            });
    }
}
